import { Link, Tooltip } from "@mui/material";
import React from "react";

type BreadcrumbLinkType = {
    text: string;
    onClick: () => void;
}

export const BreadcrumbLink: React.FC<BreadcrumbLinkType> = ({
    onClick,
    text
}) => {
    return (
        <Tooltip title={text} arrow>
            <Link
                sx={{
                    textDecoration:"none",
                    font: "normal normal 600 14px/21px Segoe UI",
                    letterSpacing: "0px",
                    color: "#22638D",
                    opacity: 1,
                    cursor: "pointer",
                    maxWidth: "210px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                    ":hover": {
                    textDecoration: "underline"
                    }
                }}                        
                onClick={onClick}
            >
                {text}
            </Link>
        </Tooltip>
    )
}